/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateBeamShapingContainerDto } from './CreateBeamShapingContainerDto';
import {
    CreateBeamShapingContainerDtoFromJSON,
    CreateBeamShapingContainerDtoFromJSONTyped,
    CreateBeamShapingContainerDtoToJSON,
} from './CreateBeamShapingContainerDto';
import type { CreateBeamQualityParameterContainerDto } from './CreateBeamQualityParameterContainerDto';
import {
    CreateBeamQualityParameterContainerDtoFromJSON,
    CreateBeamQualityParameterContainerDtoFromJSONTyped,
    CreateBeamQualityParameterContainerDtoToJSON,
} from './CreateBeamQualityParameterContainerDto';
import type { ICreateSingleSystemSetupParameter } from './ICreateSingleSystemSetupParameter';
import {
    ICreateSingleSystemSetupParameterFromJSON,
    ICreateSingleSystemSetupParameterFromJSONTyped,
    ICreateSingleSystemSetupParameterToJSON,
} from './ICreateSingleSystemSetupParameter';

/**
 * 
 * @export
 * @interface CreateOrUpdateMvTherapySystemSetupDto
 */
export interface CreateOrUpdateMvTherapySystemSetupDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateMvTherapySystemSetupDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateMvTherapySystemSetupDto
     */
    targetSystemEntityId?: string;
    /**
     * 
     * @type {Array<ICreateSingleSystemSetupParameter>}
     * @memberof CreateOrUpdateMvTherapySystemSetupDto
     */
    singleSetupParameters: Array<ICreateSingleSystemSetupParameter>;
    /**
     * 
     * @type {CreateBeamShapingContainerDto}
     * @memberof CreateOrUpdateMvTherapySystemSetupDto
     */
    beamShapingContainer: CreateBeamShapingContainerDto;
    /**
     * 
     * @type {CreateBeamQualityParameterContainerDto}
     * @memberof CreateOrUpdateMvTherapySystemSetupDto
     */
    beamQualityContainer: CreateBeamQualityParameterContainerDto;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateMvTherapySystemSetupDto
     */
    $type?: CreateOrUpdateMvTherapySystemSetupDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateMvTherapySystemSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateMvTherapySystemSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateMvTherapySystemSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateMvTherapySystemSetupDtoTypeEnum = typeof CreateOrUpdateMvTherapySystemSetupDtoTypeEnum[keyof typeof CreateOrUpdateMvTherapySystemSetupDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateMvTherapySystemSetupDto interface.
 */
export function instanceOfCreateOrUpdateMvTherapySystemSetupDto(value?: unknown): value is CreateOrUpdateMvTherapySystemSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateMvTherapySystemSetupDtoTypeEnum)[0];
}

export function CreateOrUpdateMvTherapySystemSetupDtoFromJSON(json: any): CreateOrUpdateMvTherapySystemSetupDto {
    return CreateOrUpdateMvTherapySystemSetupDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateMvTherapySystemSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateMvTherapySystemSetupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'targetSystemEntityId': json['targetSystemEntityId'] == null ? undefined : json['targetSystemEntityId'],
        'singleSetupParameters': ((json['singleSetupParameters'] as Array<any>).map(ICreateSingleSystemSetupParameterFromJSON)),
        'beamShapingContainer': CreateBeamShapingContainerDtoFromJSON(json['beamShapingContainer']),
        'beamQualityContainer': CreateBeamQualityParameterContainerDtoFromJSON(json['beamQualityContainer']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateMvTherapySystemSetupDtoToJSON(value?: CreateOrUpdateMvTherapySystemSetupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'groupId': value['groupId'],
        'targetSystemEntityId': value['targetSystemEntityId'],
        'singleSetupParameters': ((value['singleSetupParameters'] as Array<any>).map(ICreateSingleSystemSetupParameterToJSON)),
        'beamShapingContainer': CreateBeamShapingContainerDtoToJSON(value['beamShapingContainer']),
        'beamQualityContainer': CreateBeamQualityParameterContainerDtoToJSON(value['beamQualityContainer']),
        '$type': value['$type'],
    });
}

